import { v4 as uuidv4 } from "uuid";
import { nanoid } from "@reduxjs/toolkit";
const dispatchSortValues = ({
  newArray,
  dispatch,
  setSheetControls,
  Sheetid,
}) => {
  const updatedArray = newArray.map((key) => ({
    _id: "groupByFields",
    rename: key,
    uuid: uuidv4(),
    nanoId: nanoid(),
    dataType: "Number",
    columnName: key,
  }));

  dispatch(
    setSheetControls({
      Sheetid: Sheetid,
      controls: {
        uniqueColumnValues: updatedArray,
      },
    })
  );
};
const adjustOpacity = (color, vizType) => {
  const opacity = vizType === "areachart" ? 0 : 0.3;
  // Assuming color is in hex format. Convert it to RGBA and apply opacity.
  if (color.startsWith("#")) {
    if (color.startsWith("#")) {
      const hex = color.slice(1);
      const r = parseInt(hex.substring(0, 2), 20);
      const g = parseInt(hex.substring(2, 4), 20);
      const b = parseInt(hex.substring(4, 6), 20);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
    // Return original color if not in hex format
    return color;
  }
};
const stackBarChartColorArray = ({
  activeBarIndex,
  stackActiveIndex,
  stackIndex,
  barClickedCaption,
  rawGroupByKeys,
  COLORS,
  vizType,
  baseColor,

  e,
}) => {
  // console.log(activeBarIndex);

  const responseKey = rawGroupByKeys[0]?.responseKey;

  // const normalColor = COLORS[stackIndex % COLORS.length];
  const normalColor = baseColor ?? COLORS[stackIndex % COLORS.length];

  const fadedColor = adjustOpacity(normalColor, vizType);
  // console.log(normalColor, vizType);

  // Check for barClickedCaption condition
  if (stackActiveIndex.length) {
    if (
      barClickedCaption.includes(e[responseKey]) &&
      stackActiveIndex.includes(stackIndex)
    ) {
      // console.log("active stack has normal colors");
      return normalColor;
    } else {
      // console.log("non-active stack has faded colors");
      return barClickedCaption.length === 0 ? normalColor : fadedColor;
    }
  }

  if (barClickedCaption.length) {
    if (barClickedCaption.includes(e[responseKey])) {
      // console.log("active bar has normal colors");
      return normalColor;
    } else {
      // console.log("non-active bar has faded colors");
      return fadedColor;
    }
  }

  // Check for stackActiveIndex condition

  // Default color
  return normalColor;
};

const stackedBarChartPosition = (
  isAxeslabelVisible,
  isTransposeVisible,
  SufixPrefix,
  imageHeight,
  imageWidth,
  isbarXasixIconVisible,
  longestLabelWidth,
  iconMapping
) => {
  let left;
  let bottom;

  if (isbarXasixIconVisible && isTransposeVisible && isAxeslabelVisible) {
    left = Math.max(imageWidth - 30, longestLabelWidth - 30, 60);
  } else if (isbarXasixIconVisible && isTransposeVisible) {
    left = Math.max(imageWidth - 50, longestLabelWidth - 50, 60);
  } else if (isTransposeVisible && isAxeslabelVisible) {
    // console.log(longestLabelWidth);

    left = longestLabelWidth + 30;

    // left = longestLabelWidth + 40;
  } else if (isAxeslabelVisible) {
    left = longestLabelWidth + 10;
  } else if (isTransposeVisible) {
    left = longestLabelWidth + 20;
  } else if (SufixPrefix.mode && SufixPrefix.mode !== "Auto") {
    left = 4;
  } else {
    left = 10;
  }

  const top = isAxeslabelVisible
    ? 20
    : isTransposeVisible
    ? 15
    : SufixPrefix.mode && SufixPrefix.mode !== "Auto"
    ? 2
    : 20;
  //manage for bottom
  if (
    !isTransposeVisible &&
    isbarXasixIconVisible &&
    iconMapping &&
    Object.keys(iconMapping)?.length
  ) {
    bottom = imageHeight + 10;
    // console.log(bottom);
  }
  // else if (!isTransposeVisible && isbarXasixIconVisible) {
  //   bottom = imageHeight + 10

  // }
  else if (isTransposeVisible && isbarXasixIconVisible) {
    bottom = 20;
  } else if (isAxeslabelVisible) {
    bottom = 30;
    // console.log(bottom);
  } else if (isTransposeVisible) {
    bottom = 10;
    // console.log(bottom);
  } else if (SufixPrefix.mode && SufixPrefix.mode !== "Auto") {
    bottom = 4;
    // console.log(bottom);
  } else {
    bottom = 5;
    // console.log(bottom);
  }

  const right = isAxeslabelVisible
    ? 50
    : isTransposeVisible
    ? 0
    : SufixPrefix.mode && SufixPrefix.mode !== "Auto"
    ? 4
    : 6;

  return { left, top, bottom, right };
};

const removeTotalKeyValuePair = ({
  sortedData,
  TotalKeysArray,
  isTotalKeyPairValueRemoved,
}) => {
  let arrayWithOutTotals;
  let maxValue = -Infinity;

  arrayWithOutTotals = sortedData.map((item) => {
    const filteredEntries = Object.entries(item).filter(([key, value]) => {
      const isIncluded = !TotalKeysArray.includes(key);
      if (isIncluded && typeof value === "number") {
        maxValue = Math.max(maxValue, value);
      }
      return isIncluded;
    });
    return Object.fromEntries(filteredEntries);
  });

  // If no filtering is needed, we calculate max from the original sortedData
  if (!isTotalKeyPairValueRemoved) {
    maxValue = Math.max(
      ...sortedData.flatMap((d) =>
        Object.values(d).filter((v) => typeof v === "number")
      )
    );
    arrayWithOutTotals = sortedData; // Return original array
  }

  return { arrayWithOutTotals, maxValue };
};
function columIdIncludes(headerItem) {
  const { columnId } = headerItem;
  // console.log(columnId);
  if (columnId.includes("|")) return "pipe";
  if (columnId.startsWith("Total")) return "total";
  if (columnId.includes("Total")) return "underscore";
  if (columnId.includes("_")) return "underscore";
  return "none";
}

const calculateYforXaxisLabel = ({
  isbarXasixIconVisible,
  isTransposeVisible,
  iconMapping,
  imageHeight,
  imageWidth,
  x,
  y,
  width,
  height,
  isAxeslabelVisible,
}) => {
  // console.log(imageHeight);
  // console.log(y);

  // console.log(
  //   isbarXasixIconVisible,
  //   isTransposeVisible,
  //   iconMapping,
  //   imageHeight,
  //   imageWidth,
  //   x,
  //   y,
  //   width,
  //   height,
  //   isAxeslabelVisible
  // );
  if (isTransposeVisible) {
    return y + 35;
  }

  // console.log(iconMapping);

  if (isbarXasixIconVisible && Object.keys(iconMapping).length) {
    // console.log(isbarXasixIconVisible);

    // console.log(y, imageHeight);
    // console.log(y + imageHeight + 25);

    return y + imageHeight + 25;
  }
  // if (isbarXasixIconVisible && isbarXasixIconVisible) {
  //   return
  // }

  if (!isbarXasixIconVisible || Object.keys(iconMapping).length === 0) {
    return y + 35;
  }

  return 550;
};
//y asix

export {
  dispatchSortValues,
  adjustOpacity,
  stackBarChartColorArray,
  stackedBarChartPosition,
  removeTotalKeyValuePair,
  columIdIncludes,
  calculateYforXaxisLabel,
};
